<!--
 * @Description: 服务宣传语的对话框组件
 * @Author:sunhuihong
 * @Date: 2022-05-28 09:09:02
 * @LastEditTime: 2022-06-16 14:45:19
-->

<template>
  <el-dialog width="600px" :title="dialogTitle" :visible.sync="showSloganCfgDialog" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <el-form class="form" ref="sloganForm" :model="sloganForm" :rules="rules" label-width="120px" 
      style="padding: 0 30px; text-align: left;">
      <el-form-item label="宣传语内容:" prop="text" >
        <el-input size="small" clearable v-model.trim="sloganForm.text"  placeholder="请输入宣传语" 
          maxlength="30" autocomplete="off" >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('sloganForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: "SloganCfgDialog",
  props: ["showSloganCfgDialog", "sloganCfgOperate", "sloganCfgId"],
  data() {
    return {
      sloganForm: {},
      rules: {
        text: [
          { required: true, message: '请输入宣传语', trigger: 'blur' }
        ],
      },
    };
  },
  
  computed: {
    dialogTitle() {
      return this.sloganCfgOperate == "add" ? "新增宣传语" : "编辑宣传语";
    },
  },

  methods: {
    //获取编辑接口数据
    initData() {
      this.clearVaild();
      if (this.sloganCfgOperate == "edit") {
        let params = {id: this.sloganCfgId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_SLOGAN_CFG,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.sloganForm = result.data;
					}
				});
			}
    },

    //清空
    clearData() {
      this.sloganForm = {};
    },

    //确定提交表单接口调用
    handleSubmit(sloganForm) {
      this.$refs[sloganForm].validate((valid) => {
				if (!valid) return false;
				let url = this.sloganCfgOperate == "add" ? Constant.URL_SAVE_SLOGAN_CFG : Constant. URL_UPDATE_SLOGAN_CFG;
				let method = (this.sloganCfgOperate == 'add') ? 'POST' : 'PUT';
        let header = this.encryptionUtil.signatureBody(this.sloganForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: this.sloganForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
					if (result != null) {
						this.clearData();
						this.$emit("close-slogan-cfg-dialog", true);
					}
				});
			});
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-slogan-cfg-dialog", false);
    },

    clearVaild() {
      this.$nextTick(() => {
        this.$refs["sloganForm"].clearValidate();
      });
   	},
  },
};
</script>


// WEBPACK FOOTER //
// src/components/hsvccfg/components/sloganCfg/SloganCfgDialog.vue